import React from 'react';
import { connect } from 'react-redux';
import i18n from '../../../i18n/i18n';
import { Button, IconButton } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
import { SketchPicker } from 'react-color';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setInitialState, addMachinesSubgroup, getGroup } from '../../../actions/resources/MachinesActions';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Modal from '@material-ui/core/Modal';
import DialogTitle from '@material-ui/core/DialogTitle';
export class AddMachinesSubgroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            machineSubgroupObj: this.props.machineSubgroupObj,
            openModal: false,
            displayColorPicker: false
        }
    }

    componentDidMount() {
        if (this.props.machinesGroupDropdown.length == 0) {
            this.props.getGroup();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.machinesSubgroupPostingFailed === true) {
            toast.error(i18n.t('Something went wrong, please try again!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
            this.props.setInitialState('machinesSubgroupPostingFailed');
        }
    }

    addMachinesSubgroup() {
        if (this.state.machineSubgroupObj.naziv
            && this.state.machineSubgroupObj.id_pogonska_masina_grupa) {
            this.props.addMachinesSubgroup(
                this.state.machineSubgroupObj
            )

        } else {
            toast.error(i18n.t('Please enter all required fields!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
        }
    }

    handleChangeComplete = (color) => {
        let obj = Object.assign({}, this.state.machineSubgroupObj);
        obj.boja = color.hex;
        this.setState({ machineSubgroupObj: obj });
    };

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker, openModal: !this.state.openModal })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false, openModal: false })
    };

    handleChangeValue = name => event => {
        let obj = Object.assign({}, this.state.machineSubgroupObj);
        obj[name] = event.target.value;
        this.setState({ machineSubgroupObj: obj });
    };


    render() {
        let group = [];
        if (this.props.machinesGroupDropdown && !this.props.groupFetching) {
            group = this.props.machinesGroupDropdown.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }
        return (
            <div style={{ padding: 20 }}>

                {/* <Paper className="roundedBoxMaterial" zdepth={4}> */}
                <Dialog
                    open={this.props.add}
                    onClose={this.props.handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="xs"
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle disableTypography={true} className="responsive-dialog-title">{this.props.edit ? i18n.t('Edit Machine subgroup') : i18n.t('Add Machine subgroup')}
                        <IconButton onClick={this.props.handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <form id="add-machines-subgroup">
                            <Grid container justify="space-between" alignContent="space-between" spacing={16}>
                                <Grid item>
                                    <TextField
                                        select
                                        label={"Machines group"}
                                        value={this.state.machineSubgroupObj.id_pogonska_masina_grupa}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        onChange={this.handleChangeValue('id_pogonska_masina_grupa')}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        required
                                        margin="normal"
                                    // style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    >
                                        <option value='' />
                                        {group}
                                    </TextField>
                                </Grid>
                                <Grid item>
                                    <TextField
                                        required
                                        label={i18n.t('Title')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        value={this.state.machineSubgroupObj.naziv}
                                        onChange={this.handleChangeValue('naziv')}
                                    />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Icon name')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        value={this.state.machineSubgroupObj.ime_ikonice}
                                        onChange={this.handleChangeValue('ime_ikonice')} />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Priority')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        value={this.state.machineSubgroupObj.prioritet}
                                        onChange={this.handleChangeValue('prioritet')} />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Color')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px', backgroundColor: this.state.machineSubgroupObj.boja && this.state.machineSubgroupObj.boja.includes('#') ? `${this.state.machineSubgroupObj.boja}` : `#${this.state.machineSubgroupObj.boja}` }}
                                        onClick={this.handleClick}
                                        value={this.state.machineSubgroupObj.boja}
                                    >
                                    </TextField>
                                    {this.state.displayColorPicker ? <div style={{
                                        position: 'absolute',
                                        zIndex: '2',
                                    }}>
                                        <Modal
                                            aria-labelledby="simple-modal-title"
                                            aria-describedby="simple-modal-description"
                                            open={this.state.openModal}
                                            onClose={this.handleClose}
                                            style={{
                                                position: 'absolute',
                                                left: '50%',
                                                top: '50%',
                                                right: '50%',
                                                bottom: '50%',
                                            }}
                                        >
                                            <SketchPicker color={this.state.machineSubgroupObj.boja != null ? this.state.machineSubgroupObj.boja : ''} onChange={this.handleChangeComplete} />
                                        </Modal>
                                    </div> : null}
                                </Grid>
                                <Grid item xs>
                                    <Button
                                        style={{ alignSelf: 'center', backgroundColor: '#58B4E5', color: 'white' }}
                                        onClick={() => this.addMachinesSubgroup()}
                                    >
                                        {this.props.edit ? i18n.t('Save') : i18n.t('Add')}
                                    </Button>
                                </Grid>
                                <Grid item xs={3}>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                </Dialog>
                {/* </Paper> */}
            </div>

        )
    }
};

function mapStateToProps(state) {
    return {
        machinesGroupDropdown: state.machinesReducer.machinesGroupDropdown,
        groupFetching: state.machinesReducer.groupFetching,
        groupFetchingFailed: state.machinesReducer.groupFetchingFailed,
        machinesSubgroupPosting: state.machinesReducer.machinesSubgroupPosting,
        machineSubgroupObj: state.machinesReducer.machineSubgroupObj,
        machinesSubgroupPostingSuccess: state.machinesReducer.machinesSubgroupPostingSuccess,
        machinesSubgroupPostingFailed: state.machinesReducer.machinesSubgroupPostingFailed
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getGroup: () => dispatch(getGroup()),
        setInitialState: (component) => dispatch(setInitialState(component)),
        addMachinesSubgroup: (machineSubgroupObj) => dispatch(addMachinesSubgroup(machineSubgroupObj)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddMachinesSubgroup)